export default "__VITE_ASSET__8b588738__"